import Radium from '@flipdish/radium';
import * as React from 'react';
import * as Api from '../../Api';
import { Utilities } from '../../Utilities';

interface Props {
  Messages: string[];
  AppDesignScheme: Api.AppDesignScheme;
}

interface State {}

export class Toast extends React.Component<Props, State> {
  public render(): JSX.Element | null {
    const { AppDesignScheme } = this.props;

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      },
      toast: {
        backgroundColor: AppDesignScheme.Secondary
      }
    };

    if (!this.props.Messages || this.props.Messages.length < 1) {
      return null;
    }

    const content = this.props.Messages.map((m, i) => (
      <span aria-live="polite" className="primary clear-margins" key={i} style={styles.primary}>
        {m}
      </span>
    ));

    let offset: string | null = Utilities.extraOption('data-offset') || '0';

    //Macaris specific
    if (window.location.hostname == 'www.macaris.ie') {
      const header = document.getElementById('header');
      if (header) {
        offset = header.clientHeight.toString();
      }
    }

    return (
      <div className="fd-toast" aria-live="polite" style={{ top: offset }}>
        <div style={styles.toast}>{content}</div>
      </div>
    );
  }
}

export default Radium(Toast);
